import { ComponentProps, createContext, PropsWithChildren, useContext, useSyncExternalStore } from 'react'

import { UseFlowResponse } from '@cash-web/shared-flow-feature-main'

import { createExternalStore } from './createExternalStore'
import { JourneyRouter } from './JourneyRouter'

export type JourneyStoreInstance = {
  flow: UseFlowResponse
} & ComponentProps<typeof JourneyRouter>

export type JourneyStore = ReturnType<typeof createExternalStore<JourneyStoreInstance>>

export const JourneyStoreContext = createContext<JourneyStore | null>(null)

export const JourneyStoreProvider = ({ store, children }: PropsWithChildren<{ store: JourneyStore }>) => {
  return <JourneyStoreContext.Provider value={store}>{children}</JourneyStoreContext.Provider>
}

export const useJourneyStore = (journeyId: string) => {
  const store = useContext(JourneyStoreContext)
  if (!store) {
    throw new Error('JourneyStoreProvider not found')
  }
  // subscribes to a specific journeyid
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot(journeyId))
}
export const useJourneyStoreSyncOnBlockerChange = () => {
  const store = useContext(JourneyStoreContext) ?? undefined

  if (store == null) {
    throw new Error('JourneyStoreContext not found')
  }
  /**
   * this is a string of journeyId:blockerType:blockerid
   * used to determine if a blocker has been changed in any journey
   */
  const getSyncValue = () => {
    const instances = store?.getInstances()
    return Array.from(instances ?? [])
      .map(
        ([journeyId, instance]) =>
          `${journeyId}:${instance.data.flow?.active?.blockerData?.type}:${instance.data.flow?.active?.blockerData?.id}`
      )
      .join(',')
  }

  const syncValue = useSyncExternalStore(store?.subscribe, getSyncValue)

  return { store, syncValue }
}
